import React, {useMemo, useRef} from 'react';
import {useTranslate} from "../../../system/useTranslate";
import Avatar from "../../../system/components/avatar";
import Icon from "../../../system/components/icon";
import {OverlayPanel} from "primereact/overlaypanel";
import {ListBox} from "primereact/listbox";
import {InputText} from "primereact/inputtext";

const memberProfile = (membership) => membership?.member || membership;
const membershipKey = (membership) => membership?.documentId || membership?.id;

function SelectMembers({allowEmpty=false, selectedMembers, className="border-1 border-300 border-round p-1", members=[], onChange, miniSize, icon=<Icon icon="mi mi:add_circle" className="text-lg"/>}) {
    const translate = useTranslate();
    const overlayRef = useRef(null);
    const safeMembers = useMemo(
        () => Array.isArray(members) ? members : [],
        [members]
    );

    const safeSelectedMembers = useMemo(
        () => Array.isArray(selectedMembers) ? selectedMembers : [],
        [selectedMembers]
    );

    const selectedIds = useMemo(
        () => safeSelectedMembers.map(membershipKey),
        [safeSelectedMembers]
    );

    const options = useMemo(
        () => safeMembers.map((membership) => ({
            label: memberProfile(membership)?.fullname,
            value: membershipKey(membership),
            data: membership,
            disabled:
                !allowEmpty &&
                selectedIds.length === 1 &&
                selectedIds[0] === membershipKey(membership)
        })),
        [safeMembers, selectedIds, allowEmpty]
    );

    function SelectedItemTemplate({membership}) {
        const member = memberProfile(membership);
        return (
            <div className="task-involved-member-chip flex gap-2 align-items-center surface-100 border-round-3xl py-1 pr-1">
                <Avatar
                    memberData={member}
                    className="text-3xs"
                    style={{width: "1.55rem", height: "1.55rem"}}
                />

                <span className="text-xs">
                {member?.fullname}
            </span>
            </div>
        );
    }
    function ItemTemplate(option) {
        return (
            <div className="flex align-items-center gap-2 p-2">
                <Avatar
                    memberData={memberProfile(option?.data)}
                    className="text-3xs"
                    style={{width: "1.48rem", height: "1.48rem"}}
                />

                <span className="text-xs">
                {option?.label}
            </span>
            </div>
        );
    }
    return (
        <div className={`flex flex-wrap align-items-center gap-1 ${className}`}>
            {/*select members*/}

            {!miniSize && safeSelectedMembers.map((membership) => (
                <SelectedItemTemplate
                    key={membershipKey(membership)}
                    membership={membership}
                />
            ))}

            {/*pop-up button*/}

            <div
                className="flex align-items-center cursor-pointer"
                onClick={(event) => overlayRef.current?.toggle(event)}
            >
                {icon}
            </div>

            {/*pop-up*/}
            <OverlayPanel
                ref={overlayRef}
                pt={{
                    root: () => ({
                        className: "p-0 rtl w-15rem project-overlay"
                    }),
                    content: () => ({
                        className: "p-0"
                    })
                }}
            >
                <ListBox
                    className="w-15rem border-none"
                    multiple
                    checkbox
                    filter
                    filterBy="label"
                    options={options}
                    value={selectedIds}
                    optionLabel="label"
                    optionValue="value"
                    itemTemplate={ItemTemplate}
                    pt={{
                        item: () => ({
                            className: "p-0"
                        }),
                        header: () => ({
                            className: "p-1 border-none shadow-none"
                        })
                    }}
                    filterTemplate={(filterOptions) => (
                        <div className="p-2">
                            <InputText
                                className="p-2 w-full text-xs"
                                placeholder={translate("search-member-placeholder")}
                                onChange={filterOptions.filterOptions.filter}
                            />
                        </div>
                    )}
                    onChange={(event) => {
                        const nextIds = event.value ?? [];

                        const nextMembers = safeMembers.filter((membership) =>
                            nextIds.includes(membershipKey(membership))
                        );

                        onChange?.({
                            value: nextIds,
                            members: nextMembers
                        });
                    }}
                />
            </OverlayPanel>
        </div>
    )
}

export default SelectMembers;
